import ReactPixel from 'react-facebook-pixel';
import './styles/DestaqueHero.css';

function DestaqueHero() {

    const handleClickFirstBtn = () => {
        ReactPixel.track('InitiateCheckout', {
            action: 'Clique QUERO GARANTIR MINHA VAGA',
            origem: 'Seção Destaque',
        });
        ReactPixel.track('Lead', {
            action: 'Clique QUERO GARANTIR MINHA VAGA',
            origem: 'Seção Destaque',
        });
        window.open('https://pay.hotmart.com/K104003704P?off=0tb745dd&checkoutMode=10', '_blank');
        };
        

    return (
        <>
        <div className="HeroContainer">
            <div className="HeroTop">
                <div className="TextContainer">
                    <h3>Pensando nisso, o <span style={{ color: '#FF0000'}}>Grupo Biosafe</span> desenvolveu o curso <span style={{ color: '#FF0000'}}>Zona Livre de Queda e Fator de Queda</span></h3>
                    <p>Um treinamento <strong>técnico e direto ao ponto</strong> para profissionais que atuam com <strong>projetos, supervisão, liberação e execução de trabalhos em altura.</strong></p>
                </div>
                <div className="ImageContainer">
                    <div className="Image1"></div>
                </div>
            </div>
            <div className="HeroBottom">
                <div className="TextContainer">
                    <h3>Em apenas <strong><span style={{ color: '#FF0000'}}>4 horas</span></strong> de conteúdo prático você vai:</h3>
                    <p><span style={{ color: '#FF0000'}}><strong>Compreender e aplicar corretamente</strong></span> os conceitos que garantem a <strong>segurança e evitam acidentes.</strong></p>                    
                </div>
                <div className="ImageContainer">
                    <div className="Image2"></div>
                </div>
            </div>
            <button id='second-btn' onClick={handleClickFirstBtn} aria-label="Clique para garantir sua vaga no curso">QUERO GARANTIR A MINHA VAGA</button>
        </div>
        </>
    )
};

export default DestaqueHero;